import { type QueryHookOptions, useQuery } from "@apollo/client";
import { AnalyticsUsersByLinkQuery } from "../graphql/queries";
import type {
  AnalyticsUsersByLinkQueryType,
  AnalyticsUsersByLinkQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useAnalyticsUsersByLinkQuery = (
  options?: QueryHookOptions<
    AnalyticsUsersByLinkQueryType,
    AnalyticsUsersByLinkQueryVariablesType
  >
) => {
  return useQuery<
    AnalyticsUsersByLinkQueryType,
    AnalyticsUsersByLinkQueryVariablesType
  >(AnalyticsUsersByLinkQuery, options);
};
